import { styled } from '@mui/material/styles';
import { Divider } from '@mui/material';

export const StyledDivider = styled(Divider)({
  height: '50%',
  alignSelf: 'center'
}); 